module.exports = __webpack_public_path__ + "static/media/blogpagebackground.9acc23f6.png";